import { render, staticRenderFns } from "@/manager/purchase/views/convocation-list/convocation-list.pug?vue&type=template&id=4d54dde4&scoped=true&lang=pug&external"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "@/manager/purchase/views/convocation-list/convocation-list.scss?vue&type=style&index=0&id=4d54dde4&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d54dde4",
  null
  
)

export default component.exports